import React from 'react';
import PropTypes from 'prop-types';
import { Check } from 'lucide-react';
import { getUserInitials, getAccountDisplayName } from '../../helpers/accountHelpers';

/** One signed-in account: initials badge, display name, EXACT-case username,
 * and an active marker. Presentational; callers own the click behavior. */
function AccountRow({ account, active }) {
	const user = account.currentUser || { username: account.username };
	const displayName = getAccountDisplayName(user);
	return (
		<div className='flex items-center min-w-0' data-testid={`account-row-${account.username}`}>
			<span
				aria-hidden='true'
				className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
					active ? 'bg-black text-white' : 'bg-gray-100 text-gray-700'
				}`}>
				{getUserInitials(user)}
			</span>
			<span className='ml-2 flex min-w-0 flex-col'>
				<span className='truncate text-sm font-medium text-gray-900'>{displayName}</span>
				{/* The exact-case username is the identity; show it whenever the name differs */}
				{displayName !== account.username && (
					<span className='truncate text-xs text-gray-500'>{account.username}</span>
				)}
			</span>
			{active && (
				<span className='ml-auto flex items-center pl-2 text-xs font-medium text-primary'>
					<Check className='h-4 w-4' aria-hidden='true' />
					<span className='sr-only'>Active account</span>
				</span>
			)}
		</div>
	);
}

AccountRow.propTypes = {
	account: PropTypes.shape({
		username: PropTypes.string.isRequired,
		currentUser: PropTypes.object,
	}).isRequired,
	active: PropTypes.bool,
};

export default AccountRow;
